const BASE_URL = "/entry";


export default [
  {
    path: `${BASE_URL}`,
    name: "Entries",
    component: () => import("@/pages/entry/Index.vue"),
  },
  {
    path: `${BASE_URL}/item-ledger-entry/:itemId?`,
    name: "item ledger entry",
    component: () => import("@/pages/entry/itemLedgerEntry/Index.vue"),
  },
  {
    path: `${BASE_URL}/value-entry`,
    name: "value entry",
    component: () => import("@/pages/entry/valueEntry/Index.vue"),
  },
  {
    path: `${BASE_URL}/bank-account-ledger-entry`,
    name: "bank account ledger entry",
    component: () => import("@/pages/entry/bankAccountLedgerEntry/Index.vue"),
  },
  {
    path: `${BASE_URL}/bank-account-ledger-entry-detail`,
    name: "bank account ledger entry detail",
    component: () => import("@/pages/entry/bankAccountLedgerEntryDetail/Index.vue"),
  },
  {
    path: `${BASE_URL}/deposit-account-ledger-entry`,
    name: "deposit account ledger entry",
    component: () => import("@/pages/entry/depositAccountLedgerEntry/Index.vue"),
  },
  {
    path: `${BASE_URL}/deposit-account-ledger-entry-detail`,
    name: "deposit account ledger entry detail",
    component: () => import("@/pages/entry/depositAccountLedgerEntryDetail/Index.vue"),
  },
  {
    path: `${BASE_URL}/general-ledger-entry`,
    name: "general ledger entry",
    component: () => import("@/pages/entry/generalLedgerEntry/Index.vue"),
  },
  {
    path: `${BASE_URL}/physical-inventory-ledger-entry`,
    name: "physical inventory ledger entry",
    component: () => import("@/pages/entry/physicalInventoryLedgerEntry/Index.vue"),
  },
  {
    path: `${BASE_URL}/vat-entry`,
    name: "vat ledger entry",
    component: () => import("@/pages/entry/vatEntry/Index.vue"),
  },
  {
    path: `${BASE_URL}/item-application-entry`,
    name: "item application entry",
    component: () => import("@/pages/entry/itemApplicationEntry/Index.vue"),
  },
  {
    path: `${BASE_URL}/average-cost-calculation-entry/:itemId?`,
    name: "average cost calculation entry",
    component: () => import("@/pages/entry/averageCostCalculationEntry/Index.vue"),
  },
  {
    path: `${BASE_URL}/vendor-ledger-entry/:sub?`,
    name: "vendor ledger entry",
    component: () => import("@/pages/entry/vendorLedgerEntry/Index.vue"),
  },
  {
    path: `${BASE_URL}/vendor-ledger-entry-detail`,
    name: "vendor ledger entry detail",
    component: () => import("@/pages/entry/vendorLedgerEntryDetail/Index.vue"),
  },
  {
    path: `${BASE_URL}/client-ledger-entry/:sub?`,
    name: "client ledger entry",
    component: () => import("@/pages/entry/clientLedgerEntry/Index.vue"),
  }, {
    path: `${BASE_URL}/client-ledger-entry-detail`,
    name: "client ledger entry detail",
    component: () => import("@/pages/entry/clientLedgerEntryDetail/Index.vue"),
  }, {
    path: `${BASE_URL}/general-journal-entry`,
    name: "general journal entry",
    component: () => import("@/pages/entry/generalJournalEntry/Index.vue"),
  }, {
    path: `${BASE_URL}/item-journal-log`,
    name: "item journal log",
    component: () => import("@/pages/entry/itemJournalLog/Index.vue"),
  }, {
    path: `${BASE_URL}/entries-adjustment-tools`,
    name: "Adjustment Tools",
    component: () => import("@/pages/entry/AdjustmentTools.vue"),
  }, {
    path: `${BASE_URL}/entries-adjustment-tools/adjust-single-entry/:id?/:cost?`,
    name: "adjust single entry",
    component: () => import("@/pages/entry/adjustSingleEntry/Index.vue"),
  },  {
    path: `${BASE_URL}/entries-adjustment-tools/adjust-cost-item-entries`,
    name: "adjust cost item entries",
    component: () => import("@/pages/entry/adjustSOHZeroWithBalance/Index.vue"),
  },
  {
    path: `${BASE_URL}/entries-adjustment-tools/revaluation-journal-all-items`,
    name: "revaluation journal all items",
    component: () => import("@/modules/revaluation/view/RevaluationJournalAllItemsPage.vue"),
  },
];
